import React from "react";
import "./Home.css";


export default function Home() {

  return (
    <div id="home">
      <image id="character" alt="" />
      <div className="description">
        <h1 className="text1">function( ) &#123;</h1>
        <h1 className="text1 animate__animated animate__fadeInUp wow">
          const _name = " <span>ARJUN CHAUHAN</span> "
        </h1>
        <h1 className="text2 animate__animated animate__fadeInUp wow">
          console.log(" I'm a <span>FULL STACK DEVELOPER</span> ")
        </h1>
        <h1 className="text3 animate__animated animate__fadeInUp wow">
          &lt;p&gt; I turn coffee into <span className="text3-span">CODE </span>
          &lt;/p&gt;
        </h1>
        <h1 className="text1">&#125;</h1>
      </div>
    </div>
  );
}
